<template>
    <div class="">
    <ion-grid class="brach-modal stop-repeating-content">
      <ion-row class="search-view" align-items-stretch>
          <ion-col size="12" size-md="4">
              <ion-label>Corporate Name</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="corporateName"
                  @input="corporateName = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
          </ion-col>
          <ion-col size="12" size-md="4">
              <ion-label>Branch Name</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="branch"
                  @input="branch = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
          </ion-col>
          <ion-col size="12" size-md="4">
              <br />
              <ion-button class="btn-search margin-top-10" @click="searchCorporates">Search</ion-button>
              <ion-button class="btn-clear margin-top-10" @click="clearFields">
                <ion-icon :icon="refresh"></ion-icon>
              </ion-button>
          </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="list-view">
        <ion-col>
          <ion-row class="list-head">
             <!-- <ion-col size="12" size-md="2">
              <ion-label>Branch ID</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Corpoarate ID</ion-label>
            </ion-col> -->
            <ion-col size="12" size-md="2">
              <ion-label>Corpoarate Name</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Branch Name</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>GST#</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Address</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Status</ion-label>
            </ion-col>
          </ion-row>
          <hr />

          <ion-row class="list-item" v-for="(corporate) in this.corporates" :key="corporate">
            <!-- <ion-col size="12" size-md="2">
              <ion-label class="ext-link" @click="viewBranchDetails(corporate.branchId)">{{corporate.branchId}}</ion-label>
            </ion-col> -->
            <!-- <ion-col size="12" size-md="2">
              <ion-label>{{corporate.corporateId}}</ion-label>
            </ion-col> -->
            <ion-col size="12" size-md="2" @click="passCorporateData(corporate)">
              <ion-label class="ext-link">{{corporate.corporateName}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>{{corporate.branch}}</ion-label>
            </ion-col>
           
            <ion-col size="12" size-md="2">
              <ion-label>{{corporate.gstNumber}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>{{corporate.address}}</ion-label>
            </ion-col>
            <!-- <ion-col size="12" size-md="2">
              <ion-label
                v-bind:class="[{'active': station.status.id == 'A'}, {'greenfield': station.status.id == 'G'}, {'in-active': station.status.id == 'I'}, {'extinct': station.status.id == 'X'}]"
              >{{station.status.name | uppercase}}</ion-label>
            </ion-col> -->
            <ion-col size="12" size-md="2">
              <ion-label v-bind:class="[{'active': corporate.status.code == 'A'}, {'in-active': corporate.status.code == 'RET'}]">{{convertUppercase(corporate.status.description)}}</ion-label>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row v-if="norecordsfound">
        <ion-col size="12" class="ion-text-center">
          <ion-label class="pagination-info">No records found for the selected filters</ion-label>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="12" size-md="5">
          <ion-label
            class="pagination-info"
          >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
        </ion-col>
        <ion-col size="12" size-md="7" class="ion-text-right">
          <div class="pagination">
            <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
            <a class="prev disabled" v-else>Prev</a>
            <a
              
              v-for="page in this.pagesList"
              :key="page"
              v-bind:class="{'active': pageNo == page}"
              @click="loadPage(page)"
            >{{page}}</a>
            <a
              
              class="next"
              v-if="this.pageNo < this.totalPages"
              @click="loadPage(pageNo + 1)"
            >Next</a>
            <a  class="next disabled" v-else>Next</a>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { EVCStationService } from "../../service/evcstation/stations.service";
import { EVCStation, EVCStationStatus } from "../../entity/location/evcstation";

import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";

// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import { CorporateService } from "../../service/corporate/corporate.service";
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSpinner, modalController } from "@ionic/vue";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import { refresh } from "ionicons/icons";

export default defineComponent ({
    name: 'stationBranchModal',
    components: {
      IonGrid, IonRow, IonCol, IonLabel, IonInput, IonButton, IonIcon, IonSpinner, modalController
    },
    data() {
        return {
            refresh,
            loaderTab: true,
            corporates: [],
            statuses: [],
            corporateId: "",
            corporateName: "",
            branch: "",
            gstNumber: "",
            status: "",
            norecordsfound: true,
            totalRecords: 0,
            pageRecords: 10,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            
            branchId: ""
        }
    },
    async mounted() {
      try {
        this.statuses = await new CorporateService().getBranchStatus();
        var page = localStorage.getItem('branchPage');
        if(page) {
          this.pageNo = Number(page);
        }
        var search = localStorage.getItem('branchSearch');
        if(search) {
          await this.searchCorporates();
        }
        this.loaderTab = false;
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    
  },
  methods: {
    convertUppercase(value) {
      return value.toUpperCase()
    },
    passCorporateData(corporate) {
      modalController.dismiss(corporate)
    },
    viewBranchDetails(corporateId) {
      this.$router.push({
        name: "branchDetails",
        params: { corporateId: corporateId }
      });
    },
    clearFields() {
      this.corporateName = null;
      // this.branchId = null;
      this.branch = null;
      document.getElementById("corporateName").value = null;
      // document.getElementById("branchId").value = null;
      document.getElementById("branch").value = null;
      localStorage.removeItem('branchSearch');
      localStorage.removeItem('branchPage');
      this.corporates = [];
      this.norecordsfound = true;
    },

    async searchCorporates() {
      try {
        localStorage.removeItem('branchPage');
        this.pageNo = 1;
        localStorage.setItem("branchSearch", JSON.stringify({corporateName: this.corporateName, id: this.branchId,  branch: this.branch}))
        this.loaderTab = true;
        let result = await new CorporateService().corporateAtPageByPaginatedWithSizeMatchingQuery(
          this.pageNo,
          this.pageRecords,
          {
            corporateName: this.corporateName,
            id: this.branchId,
            branch: this.branch
          }
        );
        if(result.data.length != 0) {

          this.totalRecords = result.meta.totalrecords;
          this.corporates = result.data;
          (this.pagesList = new PaginationUtils().getPagesList(
            this.totalRecords,
            this.pageRecords,
            this.pageNo
          )),
          (this.totalPages = new PaginationUtils().getTotalPages(
            this.totalRecords,
            this.pageRecords
          ));
          this.norecordsfound = false;
          this.loaderTab = false;
        } else {
          this.corporates = [];
          this.norecordsfound = true;
          this.loaderTab = false;
        }
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }     
    },
    async loadPage(page) {
      try {
        localStorage.setItem('branchPage', page);
        this.loaderTab = true;
        this.pageNo = page;
        this.pagesList = new PaginationUtils().getPagesList(
          this.totalRecords,
          this.pageRecords,
          page
        );
        let result = await new CorporateService().corporateAtPageByPaginatedWithSizeMatchingQuery(
          this.pageNo,
          this.pageRecords,
          {
            corporateName: this.corporateName,
            id: this.branchId,
            branch: this.branch
          }
        );
        if(result.data.length != 0) {

          this.totalRecords = result.meta.totalrecords;
          this.corporates = result.data;
          (this.pagesList = new PaginationUtils().getPagesList(
            this.totalRecords,
            this.pageRecords,
            this.pageNo
          )),
          (this.totalPages = new PaginationUtils().getTotalPages(
            this.totalRecords,
            this.pageRecords
          ));
          this.norecordsfound = false;
          this.loaderTab = false;
        } else {
          this.corporates = [];
          this.norecordsfound = true;
          this.loaderTab = false;
        }
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }

    }
  }
})
</script>

<style scoped>

.brach-modal {
  width: 80%;
}
.select-box {
  position: relative;
  max-width: 317px;
  width: 100%;
  display: inline-block;
  margin-right: 16px;
}

.modal-fullscreen .modal-wrapper {
  position: absolute;
  display: block;
  width: 100%;
  height: 75%;
  overflow: scroll;
}
.select-box ion-select {
  max-width: 317px;
  width: 100%;
  height: 34px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 4px;
  opacity: 1;
  padding: 12px;
  padding-top: 13px;
  text-align: left;
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  line-height: 26px;
  color: #202020;
}

.select-box .custom-select-placeholder {
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
  position: absolute;
  z-index: 99;
  top: 18px;
  left: 18px;
}

.select-box .custom-select-icon {
  position: absolute;
  z-index: 99;
  top: 6px;
  background: #fff;
  right: 15px;
}
.stop-repeating-content {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  overflow: scroll;
}
.modal-fullscreen {
  position: absolute;
  display: block;
  width: 100%;
  height: 75%;
  overflow: scroll;
}
</style>